import React from 'react';
import styled from 'styled-components';
import useStrikethroughLineState from './useStrikethroughLineState';
import { BORDER_WIDTH } from '../utils';

export default function StrikethroughLine ({ state, type }) {
  const [borderColors, render] = useStrikethroughLineState({ state, type });
  const renderSecondLine = borderColors.length === 2;
  return render && (
    <StrikeLine data-testid='strike-through' width='100%' height='100%'>
      {renderSecondLine && (
        <line data-testid='outer-line'
          x1='0'
          y1='100%'
          x2='100%'
          y2='0'
          style={{ stroke: borderColors[1], strokeWidth: `${BORDER_WIDTH + 2}` }}
        />
      )}
      <line data-testid='inner-line'
        x1='0'
        y1='100%'
        x2='100%'
        y2='0'
        style={{ stroke: borderColors[0], strokeWidth: `${BORDER_WIDTH}` }}
      />
    </StrikeLine>
  );
}

const StrikeLine = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
`;
